<template>
  <bar-x-scrollable class="report-toolbar q-py-sm q-px-lg justify-between">
    <div class="q-mr-md">
      <div class="text-subtitle1">
        <i class="fa-regular fa-images q-mr-xs" />
        <strong>Album:</strong>
        {{ report.name }}
      </div>
    </div>
    <div class="flex justify-end items-center">
      <div class="on-left">
        <strong>Last Saved: </strong>
        <humanize-time :time="report.lastModified" />
      </div>
      <download-btn :report-id="report.id" flat />
    </div>
  </bar-x-scrollable>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Report } from '@/type';
import BarXScrollable from '@/layout/BarXScrollable.vue';
import HumanizeTime from '@/components/HumanizeTime.vue';
import DownloadBtn from './DownloadBtn.vue';

export default defineComponent({
  components: {
    BarXScrollable,
    HumanizeTime,
    DownloadBtn,
  },
  props: {
    report: {
      type: Object as () => Report,
      required: true,
    },
  },
});
</script>
